export function getDateArray(startDate, endDate) {
  const start = new Date(startDate)
  const end = new Date(endDate)
  const dateArray = []
  const currentDate = start

  while (currentDate <= end) {
    dateArray.push(currentDate.toISOString().split('T')[0])
    currentDate.setDate(currentDate.getDate() + 1)
  }

  return dateArray
}

export function getSmallDateArray(dates) {
  return dates.map((dateStr) => {
    const date = new Date(dateStr)
    const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based in JavaScript
    const day = String(date.getDate()).padStart(2, '0')
    return `${month}-${day}`
  })
}

export function deleteDataAtIntervals(array) {
  let interval
  if (array.length > 40) {
    interval = 4
  } else if (array.length >= 30) {
    interval = 4
  } else if (array.length > 20) {
    interval = 0
  } else {
    interval = 0 // For arrays with size 10 or less, no deletion
  }

  return array.filter((_, index) => index % interval !== 0)
}

export const formatDateString = (dateString) => {
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export const sortByDate = (array) => {
  return array.sort((a, b) => {
    // Convert ISO 8601 date strings to Date objects
    const dateA = new Date(a.created)
    const dateB = new Date(b.created)

    // Compare dates
    return dateB - dateA
  })
}
